// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.siteFooter {
  background: #2fb7e7;
  color: #ffffff;
  margin-top: 10px;
}

.footerInner {
  max-width: 730px;
  margin: 0 auto;
  padding: 22px 20px 18px;

  display: grid;
  grid-template-columns: minmax(0, 1fr) 260px;
  gap: 24px;
  align-items: center;
}

.footerLeft {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.footerLogo {
  font-size: 29px;
  font-weight: 800;
  line-height: 1;
  margin-bottom: 14px;
  color: #016faf;
}

.footerTagline {
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0.16em;
  color: #ffffff;
  line-height: 1.2;
  margin-top: -8px;
  margin-bottom: 18px;
}

.footerDot {
  color: #ffb703;
}

.footerNav {
  display: grid;
  grid-template-columns: 1fr;
  gap: 12px;
}

.footerNav a {
  color: #ffffff;
  text-decoration: none;
  font-size: 16px;
  font-weight: 500;
  line-height: 1.2;
  white-space: nowrap;
}

.footerNav a:hover {
  text-decoration: underline;
}

.footerRight {
  display: flex;
  align-items: center;
  justify-content: center;
}

.footerMascot {
  max-width: 220px;
  height: auto;
  width: 100%;
}

html[data-brand="house-helper"] .siteFooter {
  background: #2f7d32;
}

html[data-brand="house-helper"] .footerLogo {
  color: #edf8e7;
}

html[data-brand="house-helper"] .footerDot {
  color: #f4c430;
}

.footerBottom {
  border-top: 1px solid rgba(255, 255, 255, 0.2);
  max-width: 730px;
  margin: 0 auto;
  padding: 24px 20px 18px;

  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 18px;
}

.footerSocial {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 18px;
}

.footerSocial a {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background: #ffffff;
  color: #2f55e7;

  display: flex;
  align-items: center;
  justify-content: center;

  font-size: 19px;
  font-weight: 700;
  text-decoration: none;
}

.footerCopyright {
  font-size: 15px;
  opacity: 0.9;
  color: white;
  line-height: 1.4;
  text-align: center;
}

.footerCopyright .regtrade,
.footerCopyright .brand_small {
  line-height: 1;
}

.footerCopyright .regtrade {
  font-size: 0.48em;
  vertical-align: super;
  margin-left: 1px;
  margin-right: 0;
  line-height: inherit;
  color: inherit;
  font-weight: inherit;
}

.footerCopyright .brand_small {
  font-size: 0.72em;
  vertical-align: baseline;
  display: inline-block;
  margin-left: -1px;
  transform: translateY(0.16em);
  color: inherit;
  font-weight: inherit;
  letter-spacing: normal;
  filter: none;
}

.footerDotBiz {
  color: #ffe3aa;
  font-weight: 700;
  font-size: 0.75em;
}

.regtrade-footer {
  color: #ffe3aa;
  font-weight: 700;
  font-size: 0.45em;
  margin-bottom: 50px;
}

@media (max-width: 700px) {
  .footerInner {
    grid-template-columns: 1fr;
    text-align: center;
    gap: 18px;
  }

  .footerLeft {
    align-items: center;
  }

  .footerNav {
    align-items: center;
  }

  .footerRight {
    order: -1;
  }
}

@media (max-width: 550px) {

  .siteFooter {
    padding: 10px 16px 20px;
  }

  .footerInner {
    gap: 16px;
    padding: 20px 16px 16px;
  }

  .footerRight {
    justify-content: center;
  }

  .footerMascot {
    max-width: 170px;
  }

  /* Logo sizing */
  .footerLogo {
    font-size: 22px;
    margin-bottom: 8px;
  }

  .footerTagline {
    margin-top: 0;
    margin-bottom: 16px;
    font-size: 12px;
  }

  .footerNav {
    display: grid;
    grid-template-columns: repeat(2, max-content);
    justify-content: center;
    gap: 8px 22px;
    width: 100%;
    max-width: 100%;
    margin: 0 auto;
  }

  .footerNav a {
    font-size: 14px;
    text-decoration: none;
    padding: 6px 0;
    justify-self: center;
  }

  .footerBottom {
    flex-direction: column;
    gap: 12px;
    margin-top: 12px;
    padding: 24px 16px 0;
    text-align: center;
  }

  .footerSocial {
    justify-content: center;
    gap: 12px;
  }

  .footerCopyright {
    font-size: 12px;
    max-width: 300px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/assets/stylesheets/Footer.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,uBAAuB;;EAEvB,aAAa;EACb,2CAA2C;EAC3C,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,SAAS;AACX;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,8CAA8C;EAC9C,gBAAgB;EAChB,cAAc;EACd,uBAAuB;;EAEvB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;;EAEd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;;EAEvB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;EACxB,qBAAqB;EACrB,iBAAiB;EACjB,6BAA6B;EAC7B,cAAc;EACd,oBAAoB;EACpB,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE;IACE,0BAA0B;IAC1B,kBAAkB;IAClB,SAAS;EACX;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,SAAS;EACX;AACF;;AAEA;;EAEE;IACE,uBAAuB;EACzB;;EAEA;IACE,SAAS;IACT,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,gBAAgB;EAClB;;EAEA,gBAAgB;EAChB;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,6CAA6C;IAC7C,uBAAuB;IACvB,aAAa;IACb,WAAW;IACX,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,eAAe;IACf,qBAAqB;IACrB,cAAc;IACd,oBAAoB;EACtB;;EAEA;IACE,sBAAsB;IACtB,SAAS;IACT,gBAAgB;IAChB,oBAAoB;IACpB,kBAAkB;EACpB;;EAEA;IACE,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;AACF","sourcesContent":[".siteFooter {\n  background: #2fb7e7;\n  color: #ffffff;\n  margin-top: 10px;\n}\n\n.footerInner {\n  max-width: 730px;\n  margin: 0 auto;\n  padding: 22px 20px 18px;\n\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) 260px;\n  gap: 24px;\n  align-items: center;\n}\n\n.footerLeft {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n}\n\n.footerLogo {\n  font-size: 29px;\n  font-weight: 800;\n  line-height: 1;\n  margin-bottom: 14px;\n  color: #016faf;\n}\n\n.footerTagline {\n  font-size: 14px;\n  font-weight: 600;\n  letter-spacing: 0.16em;\n  color: #ffffff;\n  line-height: 1.2;\n  margin-top: -8px;\n  margin-bottom: 18px;\n}\n\n.footerDot {\n  color: #ffb703;\n}\n\n.footerNav {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 12px;\n}\n\n.footerNav a {\n  color: #ffffff;\n  text-decoration: none;\n  font-size: 16px;\n  font-weight: 500;\n  line-height: 1.2;\n  white-space: nowrap;\n}\n\n.footerNav a:hover {\n  text-decoration: underline;\n}\n\n.footerRight {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.footerMascot {\n  max-width: 220px;\n  height: auto;\n  width: 100%;\n}\n\nhtml[data-brand=\"house-helper\"] .siteFooter {\n  background: #2f7d32;\n}\n\nhtml[data-brand=\"house-helper\"] .footerLogo {\n  color: #edf8e7;\n}\n\nhtml[data-brand=\"house-helper\"] .footerDot {\n  color: #f4c430;\n}\n\n.footerBottom {\n  border-top: 1px solid rgba(255, 255, 255, 0.2);\n  max-width: 730px;\n  margin: 0 auto;\n  padding: 24px 20px 18px;\n\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 18px;\n}\n\n.footerSocial {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 18px;\n}\n\n.footerSocial a {\n  width: 44px;\n  height: 44px;\n  border-radius: 50%;\n  background: #ffffff;\n  color: #2f55e7;\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  font-size: 19px;\n  font-weight: 700;\n  text-decoration: none;\n}\n\n.footerCopyright {\n  font-size: 15px;\n  opacity: 0.9;\n  color: white;\n  line-height: 1.4;\n  text-align: center;\n}\n\n.footerCopyright .regtrade,\n.footerCopyright .brand_small {\n  line-height: 1;\n}\n\n.footerCopyright .regtrade {\n  font-size: 0.48em;\n  vertical-align: super;\n  margin-left: 1px;\n  margin-right: 0;\n  line-height: inherit;\n  color: inherit;\n  font-weight: inherit;\n}\n\n.footerCopyright .brand_small {\n  font-size: 0.72em;\n  vertical-align: baseline;\n  display: inline-block;\n  margin-left: -1px;\n  transform: translateY(0.16em);\n  color: inherit;\n  font-weight: inherit;\n  letter-spacing: normal;\n  filter: none;\n}\n\n.footerDotBiz {\n  color: #ffe3aa;\n  font-weight: 700;\n  font-size: 0.75em;\n}\n\n.regtrade-footer {\n  color: #ffe3aa;\n  font-weight: 700;\n  font-size: 0.45em;\n  margin-bottom: 50px;\n}\n\n@media (max-width: 700px) {\n  .footerInner {\n    grid-template-columns: 1fr;\n    text-align: center;\n    gap: 18px;\n  }\n\n  .footerLeft {\n    align-items: center;\n  }\n\n  .footerNav {\n    align-items: center;\n  }\n\n  .footerRight {\n    order: -1;\n  }\n}\n\n@media (max-width: 550px) {\n\n  .siteFooter {\n    padding: 10px 16px 20px;\n  }\n\n  .footerInner {\n    gap: 16px;\n    padding: 20px 16px 16px;\n  }\n\n  .footerRight {\n    justify-content: center;\n  }\n\n  .footerMascot {\n    max-width: 170px;\n  }\n\n  /* Logo sizing */\n  .footerLogo {\n    font-size: 22px;\n    margin-bottom: 8px;\n  }\n\n  .footerTagline {\n    margin-top: 0;\n    margin-bottom: 16px;\n    font-size: 12px;\n  }\n\n  .footerNav {\n    display: grid;\n    grid-template-columns: repeat(2, max-content);\n    justify-content: center;\n    gap: 8px 22px;\n    width: 100%;\n    max-width: 100%;\n    margin: 0 auto;\n  }\n\n  .footerNav a {\n    font-size: 14px;\n    text-decoration: none;\n    padding: 6px 0;\n    justify-self: center;\n  }\n\n  .footerBottom {\n    flex-direction: column;\n    gap: 12px;\n    margin-top: 12px;\n    padding: 24px 16px 0;\n    text-align: center;\n  }\n\n  .footerSocial {\n    justify-content: center;\n    gap: 12px;\n  }\n\n  .footerCopyright {\n    font-size: 12px;\n    max-width: 300px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
